import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import $ from "jquery";
import { getTrans as T } from "../../../Shared/Language";
import {
  AddAnnouncement,
  getAnnouncement,
} from "./Services/AnnouncementService";
import moment from "moment";
import { uploadDoc } from "../../../Services/Global-Services/GlobalServices";
import ImageCropperModal from "../../../Services/Comment/ImageCropperModal";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { Editor } from "primereact/editor";
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);
const defaultImage = "/images/no-data-found/announcement01.jpg";
function AnnouncementEdit() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [today, setToday] = useState("");
  const inputFile = useRef(null);
  const [file, setFile] = useState(null);
  const [annoouncementId, setAnnoouncementId] = useState(0);
  const { GUID } = useParams();
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [acceptRatio, setAcceptRatio] = useState(0);
  let history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const currentDay = new Date().toISOString().split("T")[0];
  const [type, setType] = useState("");
  const [docUploadError, setDocUploadError] = useState("");

  useEffect(() => {
    if (GUID?.length >= 0) {
      GetAnnouncement();
    } else {
      AnnouncementForm.resetForm();
      inputFile.current.value = "";
    }
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
      // else if (msg?.Name == message && type == 1) {
      // 	setErrorMessage(msg?.Desc);
      // }
      // else if (msg?.Name == message && type == 2) {
      // 	setMasterSystemAlertData(msg?.Desc);
      // }
    });
  }, []);

  const AnnouncementValidation = useMemo(
    () =>
      Yup.object().shape({
        Desc: Yup.string().required("Announcement is required."),
        Date: Yup.string()
          .required("Schedule date is required.")
          .test(
            "is-today-or-future",
            "Date cannot be in the past",
            function (value) {
              return value >= currentDay;
            }
          ),
        Title: Yup.string().required("Title is required."),
        Image: Yup.string(),
        Document: Yup.string(),
        ModifiedByName: Yup.string(),
        ModifiedByNameImage: Yup.string(),
      }),
    []
  );

  const AnnouncementForm = useFormik({
    initialValues: {
      Title: "",
      Date: "",
      Desc: "",
      Image: "",
      Document: "",
      ModifiedByName: "",
      ModifiedByNameImage: "",
    },
    validationSchema: AnnouncementValidation,
    onSubmit: async (data) => {
      let Document = [];
      setIsloading(true);
      if (data?.Document) {
        Document = data?.Document.split(",");
      }
      const body = {
        Id: data?.Id ?? 0,
        Title: data.Title,
        Date: data.Date,
        Desc: data.Desc,
        Image: data.Image,
        OrgId: userDetails?.OrgId,
        ModifiedBy: userDetails?.EmpId,
        Document: Document,
      };
      try {
        await AddAnnouncement(body);
        if (data?.Id) {
          GetMasterSystemAlertList("Announcement_update", 0);
          setIsloading(false);
        } else {
          GetMasterSystemAlertList("Announcement_added", 0);
          setIsloading(false);
        }
        setIsloading(false);
        $("#award-popup")?.click();
        history.push(`/Announcement`);
      } catch (err) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });

  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setToday(formattedDate);
  }, []);

  async function GetAnnouncement() {
    setIsloading(true);
    const params = {
      Id: 0,
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      year: "",
      AnnouncementType: 0,
      FutureAnnouncement: 1,
      GUID: GUID,
      PageNumber: 1,
      PageSize: 1,
    };
    try {
      const response = await getAnnouncement(params);
      setIsloading(false);
      let AnnouncementList = response?.Data[0];
      let docs = AnnouncementList?.AnnouncementDocuments?.map(
        (doc) => doc?.Document
      ).join(",");
      setAnnoouncementId(AnnouncementList.Id);
      const AnnouncementValue = {
        Title: AnnouncementList.Title,
        Date: AnnouncementList.Date,
        Desc: AnnouncementList.Desc,
        Image: AnnouncementList.Image,
        Id: AnnouncementList.Id,
        OrgId: AnnouncementList.OrgId,
        EmpId: AnnouncementList.EmpId,
        Date: AnnouncementList?.Date?.split("T")[0],
        ModifiedBy: AnnouncementList?.ModifiedBy,
        Document: docs,
        ModifiedByName: AnnouncementList?.ModifiedByName,
        ModifiedByNameImage: AnnouncementList?.ModifiedByProfileImage,
      };
      AnnouncementForm.setValues(AnnouncementValue);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  function RecetAnnouncementForm() {
    AnnouncementForm.resetForm();
    inputFile.current.value = "";
    history.push(`/Announcement`);
  }

  const handleFileChange = async (event, type) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setType(type);
      setShowCropper(true);
      setAcceptRatio(2.35 / 1);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  const handleCropComplete = (croppedBlob) => {
    setFile([new File([croppedBlob], "cropped.jpg", { type: "image/jpeg" })]);
  };

  const handleFileChangeDoc = (event, type) => {
    const files = event.target.files;
    const fileArray = Array.from(files);
    const supportedExtensions = ["doc", "docx", "zip", "pdf", "xls", "xlsx", "csv"];
    const unsupportedFiles = [];

    if (fileArray.length > 0) {
      const validFiles = fileArray.filter((file) => {
        const fileExt = file.name.split(".").pop().toLowerCase();
        if (!supportedExtensions.includes(fileExt)) {
          unsupportedFiles.push(file.name);
          return false;
        }
        return true;
      });

      if (unsupportedFiles.length > 0) {
        setDocUploadError("This file is not supported.");
        event.target.value = "";
        return;
      } else {
        setDocUploadError("");
      }

      if (validFiles.length > 0) {
        setFile(validFiles);
        setType(type);
      }
    }
    event.target.value = "";
  };

  useEffect(() => {
    if (file) {
      uploadPolicyDocFile(type);
    }
  }, [file, type]);

  async function uploadPolicyDocFile(type) {
    setIsloading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Announcement,
        RefId: annoouncementId,
      };

      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        if (type == 0) {
          const imageValue = ImageURL.join(", ");
          AnnouncementForm.setFieldValue("Image", imageValue);
        } else {
          if (AnnouncementForm.values.Document) {
            const existingDocuments = AnnouncementForm.values.Document.split(
              ","
            ).map((doc) => doc.trim());
            const updatedDocuments = [
              ...new Set([...existingDocuments, ...ImageURL]),
            ];
            const documentValue = updatedDocuments.join(", ");
            AnnouncementForm.setFieldValue("Document", documentValue);
            AnnouncementForm.setFieldValue(
              "ModifiedByName",
              userDetails?.FullName
            );
          } else {
            const documentValue = ImageURL.join(", ");
            AnnouncementForm.setFieldValue("Document", documentValue);
            AnnouncementForm.setFieldValue(
              "ModifiedByName",
              userDetails?.FullName
            );
          }
        }
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
      }
    } else {
      setIsloading(false);
      toster.current.warn("No file selected");
    }
  }

  const deleteFile = (event) => {
    const deleteThisUrl = event;
    const documentValue = AnnouncementForm?.values?.Document || "";
    const fileData = documentValue.split(",");
    const updatedData = fileData.filter((doc) => doc !== deleteThisUrl);
    AnnouncementForm.setFieldValue("Document", updatedData.join(","));
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const fileTypes = [
    { ext: "doc", name: "Doc", icon: "/images/tickets/doc.JPG" },
    { ext: "docx", name: "Docx", icon: "/images/tickets/doc.JPG" },
    { ext: "zip", name: "Zip", icon: "/images/tickets/zip.png" },
    { ext: "pdf", name: "Pdf", icon: "/images/tickets/pdf.png" },
    { ext: "xls", name: "Excel", icon: "/images/tickets/excel.png" },
    { ext: "xlsx", name: "Excel", icon: "/images/tickets/excel.png" },
    { ext: "csv", name: "Excel CSV", icon: "/images/tickets/excel.png" },
  ];

    const headerTemplate = (
    <span className="ql-formats0">
      <select className="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <select className="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <select className="ql-color"></select>
      <select className="ql-background"></select>
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <select className="ql-align"></select>
      <button className="ql-link"></button>
      <button className="ql-code-block"></button>
      <button className="ql-clean"></button>
    </span>
  );

  return (
    <>
      <div id="circular-menu" className="circular-menu position-relation">
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              stroke-linejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link href="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </Link>
        </div>
      </div>

      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row">
                <div className="col-lg-10 shrink-w">
                  <div className="form-head d-flex flex-wrap align-items-center mb-4">
                    <div className="me-auto">
                      {GUID ? (
                        <h2 className="font-w600 mb-0">Edit Announcement</h2>
                      ) : (
                        <h2 className="font-w600 mb-0"> New Announcement</h2>
                      )}
                    </div>
                    <div className="rightside-tabs">
                      <Link to="/Announcement">
                        <button className="back-newticket w-auto float-right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="currentColor"
                            className="bi bi-arrow-left-short"
                            viewBox="0 0
   16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12 8a.5.5 0 0 1-.5.5H5.7
   07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
   .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                            ></path>
                          </svg>{" "}
                          Back
                        </button>
                      </Link>
                    </div>
                  </div>

                  <form onSubmit={AnnouncementForm.handleSubmit}>
                    <div className="row">
                      <div className="col-xl-8">
                        <div className="employee-card tile-grid tile-grid-v1">
                          <div id="feed-post-1" className="AnnouncementForm">
                            <div className="third-section">
                              <div className="row">
                                <div className="mb-4 col-md-12">
                                  <p className="form-label-file">
                                    Title<i className="inValidError">*</i>
                                  </p>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-sticky-note-o"
                                      aria-hidden="true"
                                    ></i>
                                    <input
                                      type="text"
                                      className={
                                        "form-control" +
                                        (AnnouncementForm.errors.Title &&
                                          AnnouncementForm.touched.Title
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={AnnouncementForm.handleChange}
                                      value={AnnouncementForm.values.Title}
                                      placeholder="Title"
                                      name="Title"
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {AnnouncementForm.errors.Title &&
                                      AnnouncementForm.touched.Title
                                      ? AnnouncementForm.errors.Title
                                      : null}
                                  </div>
                                </div>
                                <div className="mb-4 col-md-12">
                                  <p className="form-label-file">
                                    Schedule Date
                                    <i className="inValidError">*</i>
                                  </p>
                                  <div className="cover-form">
                                    <i
                                      className="fa fa-calendar-o "
                                      aria-hidden="true"
                                    ></i>
                                    <input
                                      type="Date"
                                      name="Date"
                                      onClick={(e) =>
                                        e.target.showPicker &&
                                        e.target.showPicker()
                                      }
                                      className={
                                        "form-control" +
                                        (AnnouncementForm.errors.Date &&
                                          AnnouncementForm.touched.Date
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onFocus="this.Date"
                                      onChange={AnnouncementForm.handleChange}
                                      onBlur={AnnouncementForm.handleBlur}
                                      value={AnnouncementForm.values.Date}
                                      placeholder="Date"
                                      min={today}
                                    />
                                  </div>
                                  {AnnouncementForm.errors.Date &&
                                    AnnouncementForm.touched.Date && (
                                      <div className="invalid-feedback">
                                        {AnnouncementForm.errors.Date}
                                      </div>
                                    )}
                                </div>{" "}
                                <div className="mb-4 col-md-12">
                                  <p className="form-label-file">
                                    Announcement
                                    <i className="inValidError">*</i>
                                  </p>
                                  <div className="bg-white w-100">
                                    <Editor
                                      name="Desc"
                                      value={AnnouncementForm.values.Desc}
                                      onTextChange={(e) => {
                                        AnnouncementForm.setFieldValue(
                                          "Desc",
                                          e.htmlValue
                                        );
                                      }}
                                      headerTemplate={headerTemplate}
                                      style={{ height: "320px" }}
                                      onBlur={() =>
                                        AnnouncementForm.setFieldTouched(
                                          "Desc",
                                          true
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {AnnouncementForm.errors.Desc &&
                                      AnnouncementForm.touched.Desc
                                      ? AnnouncementForm.errors.Desc
                                      : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="btns-grp text-end">
                            <button
                              type="submit"
                              className="cancelbtn-click"
                              fdprocessedid="5mw059"
                              onClick={RecetAnnouncementForm}
                            >
                              Cancel
                            </button>
                            {GUID ? (
                              <button
                                type="submit"
                                className="savebtn-click"
                                fdprocessedid="jjj57m"
                              >
                                Update
                              </button>
                            ) : (
                              <button
                                type="submit"
                                className="savebtn-click"
                                fdprocessedid="jjj57m"
                              >
                                Save
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="row">
                          <div className="col-xl-12">
                            <p className="form-label-file">Banner Image</p>
                            <div className="card">
                              <div className="card-body">
                                <div>
                                  <div className="inner">
                                    {AnnouncementForm?.values?.Image?.trim() ? (
                                      <img
                                        src={AnnouncementForm.values.Image}
                                        className="editaddimg"
                                        onError={handleImageError}
                                      />
                                    ) : (
                                      <img
                                        src={defaultImage}
                                        className="editaddimg"
                                      />
                                    )}
                                  </div>
                                  <label
                                    htmlFor="file-upload"
                                    className="custom-file-upload loadresumes"
                                  >
                                    <i
                                      className="fa fa-upload me-2"
                                      aria-hidden="true"
                                    ></i>
                                    Upload Banner Image
                                  </label>

                                  {showCropper && imageSrc && (
                                    <ImageCropperModal
                                      image={imageSrc}
                                      onCropComplete={handleCropComplete}
                                      onClose={() => setShowCropper(false)}
                                      acceptRatio={acceptRatio}
                                    />
                                  )}

                                  <input
                                    ref={inputFile}
                                    type="file"
                                    multiple={false} // better to use boolean instead of empty string
                                    id="file-upload"
                                    className="form-control loadresumes"
                                    name="BannerImage"
                                    accept="image/png, image/gif, image/jpeg"
                                    style={{ display: "none" }}
                                    onChange={(event) =>
                                      handleFileChange(event, 0)
                                    }
                                  />
                                </div>
                                {/* <div className="invalid-feedback">
                                  {AnnouncementForm.errors.Image &&
                                  AnnouncementForm.touched.Image
                                    ? AnnouncementForm.errors.Image
                                    : null}
                                </div> */}
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-12">
                            <p className="form-label-file">File Attachments</p>
                            <div className="card">
                              <div className="card-body">
                                {AnnouncementForm?.values?.Document?.length >
                                  0 && (
                                    <div className="announcement-attchment mt-0">
                                      {AnnouncementForm?.values?.Document?.split(
                                        ","
                                      )?.map((lst, index) => {
                                        const fileExt = lst
                                          ?.split(".")
                                          .pop()
                                          ?.toLowerCase()
                                          .split("?")[0];
                                        const fileType = fileTypes.find(
                                          (f) => f.ext === fileExt
                                        );

                                        if (!fileType) return null;

                                        const uploaderImage =
                                          AnnouncementForm?.values
                                            ?.ModifiedByNameImage ||
                                          userDetails?.ProfileImage;
                                        const uploaderName =
                                          AnnouncementForm?.values
                                            ?.ModifiedByName ||
                                          userDetails?.FullName;

                                        return (
                                          <div className="filediv" key={index}>
                                            <div className="file_detail">
                                              <div className="image">
                                                <img
                                                  src={fileType.icon}
                                                  alt={fileType.name}
                                                  width="100%"
                                                  style={{ borderRadius: "100%" }}
                                                />
                                              </div>
                                              <span>
                                                <h6>{fileType.name}</h6>
                                                <span className="bypersom-date">
                                                  By
                                                  <a
                                                    href={lst}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <img
                                                      src={uploaderImage}
                                                      alt="Uploader"
                                                    />
                                                    {uploaderName}
                                                  </a>
                                                </span>
                                              </span>
                                            </div>

                                            <div
                                              className="ticket-file-attach__items_download"
                                              style={{ background: "#ffffff" }}
                                            >
                                              <a>
                                                <i
                                                  onClick={() => deleteFile(lst)}
                                                  className="fa fa-trash-o"
                                                  style={{ color: "red" }}
                                                ></i>
                                              </a>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                <label
                                  htmlFor="doc-upload"
                                  className="custom-file-upload loadresumes"
                                >
                                  <i
                                    className="fa fa-upload me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Upload Files
                                </label>
                                <input
                                  accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.zip,application/pdf"
                                  ref={inputFile}
                                  type="file"
                                  multiple={true}
                                  id="doc-upload"
                                  className={
                                    "form-control" +
                                    (AnnouncementForm.errors.Document &&
                                      AnnouncementForm.touched.Document
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="BannerDocument"
                                  style={{ display: "none" }}
                                  onChange={(event) =>
                                    handleFileChangeDoc(event, 1)
                                  }
                                />
                                {docUploadError && (
                                  <div className="invalid-feedback d-block mt-2 text-center" style={{ color: "#dc3545" }}>
                                    {docUploadError}
                                  </div>
                                )}
                                <div>
                                  <div className="invalid-feedback">
                                    {AnnouncementForm.errors.Document &&
                                      AnnouncementForm.touched.Document
                                      ? AnnouncementForm.errors.Document
                                      : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default AnnouncementEdit;
